import { render } from "./LevelChart.vue?vue&type=template&id=6d605faa&scoped=true"
import script from "./LevelChart.vue?vue&type=script&lang=ts"
export * from "./LevelChart.vue?vue&type=script&lang=ts"

import "./LevelChart.vue?vue&type=style&index=0&id=6d605faa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d605faa"

export default script